export default {
  title: 'Wyjątki harmonogramu',
  fields: {
    status: {
      label: 'Status',
    },
    date: {
      label: 'Data',
    },
    description: {
      label: 'Powód',
    },
    recurring: {
      label: 'Cyklicznie co roku',
    },
    created: {
      label: 'Utworzono',
      creator: 'przez {{name}}',
    },
    updated: {
      label: 'Zaktualizowano',
    },
  },
  status: {
    closed: 'Zamknięte',
    open: 'Otwarte',
    paused: 'Wstrzymane',
  },
  date: {
    all_day: 'Cały dzień',
    paused_until_rest_of_day: 'Wstrzymane do końca dnia',
  },
  buttons: {
    pause_availability: '+ Wstrzymaj dostępność',
    close_availability: '+ Zamknij dostępność',
    amend_availability: '+ Zmień dostępność',
    sync_from_online_shop: 'Synchronizuj ze sklepu online',
    close: 'Zamknij',
    delete: 'Usuń',
  },
  projects: {
    online_shop: 'Sklep online',
    reservations: 'Rezerwacje',
    storefront: 'Witryna',
  },
  error_messages: {
    delete_failed: 'Nie udało się usunąć. Spróbuj ponownie.',
  },
  toasts: {
    sync_success: 'Synchronizacja zakończona pomyślnie',
    sync_error: 'Nie udało się zsynchronizować wyjątków harmonogramu ze sklepu online. Spróbuj ponownie.',
  },
};
